import axios from 'axios'
import { ADMIN_URL } from 'shared/app-settings';
import { store } from "../store";

var access_token = localStorage.getItem('access_token');

const dangbaiService = {
    getdetail(body) {
        return axios.get(ADMIN_URL + 'detail-dangbai', {
            params: body,
            headers: {
                Authorization: `${access_token}`
            },
        });
    },
    getList() {
        return axios.get(ADMIN_URL + 'list-dangbai', {
            headers: {
                Authorization: `${access_token}`
            },
        });
    },
}
export { dangbaiService };